import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  LoadInsights,
  LoadInsightsCsv,
  SetInsights,
  SetInsightsApiError,
  InsightsCsvLoaded,
} from './insights.actions';
import { mergeMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { InsightsApiError, InsightsApiErrorTypes } from './insights.errors';
import { Insights } from './insights.model';
import { InsightsService } from './insights.service';
import { DownLoadFileService } from 'src/app/shared/services/download-file.service';

@Injectable()
export class InsightsEffects {
  loadInsights$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadInsights),
      mergeMap(({ projectId, filters }) =>
        this.insightsService.loadInsights(projectId, filters).pipe(
          map((insights: Insights) => SetInsights({ insights })),
          catchError((error) =>
            of(
              SetInsightsApiError({
                error: new InsightsApiError(InsightsApiErrorTypes.LoadInsightsError, error),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  loadInsightsCsv$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadInsightsCsv),
      mergeMap(({ projectId, filters }) =>
        this.insightsService.loadInsightsCsv(projectId, filters).pipe(
          map((blob: Blob) => {
            const { daterange, device, chartDataTypes } = filters;
            const filename = `project-${projectId}-${chartDataTypes.replace(
              ',',
              '-',
            )}-daterange-${daterange}-device-${device}.csv`;
            this.downloadFileService.blobToFile(
              blob,
              'application/octet-stream',
              `${filename}.csv`,
            );
            return InsightsCsvLoaded();
          }),
          catchError((error) =>
            of(
              SetInsightsApiError({
                error: new InsightsApiError(InsightsApiErrorTypes.LoadInsightsError, error),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private insightsService: InsightsService,
    private actions$: Actions,
    private downloadFileService: DownLoadFileService,
  ) {}
}
